import { userLanguage, ValidLanguages } from '$translations/index';
import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { FormTypes } from '../../../../types/user_info';
import { successHandler, errorHandler } from '../../../utils';
import {
  AddMultipleCandidateSkillsInput,
  AddMultipleCandidateSkillsOutput,
  CandidateSkillBuilder,
} from '../candidate-skill.types';

export const addMultipleCandidateSkills = (builder: CandidateSkillBuilder) =>
  builder.mutation<
    AddMultipleCandidateSkillsOutput,
    AddMultipleCandidateSkillsInput
  >({
    query: ({ skills }) => ({
      url: `/candidate-skills/add-range`,
      method: 'POST',
      body: skills.map((o: FormTypes['skills']) => ({
        Id: o?.Id,
        SkillLevel: o?.SkillLevel.val,
        Skill: o?.Skill.Id,
        CertificationId: o?.CertificationId.val,
        CertificationUrl: o?.CertificationUrl.val,
        CertificationDate: o?.certDate.val ? `${o?.certDate.val}-02` : null,
      })),
    }),
    invalidatesTags: [{ type: 'candidateSkills', id: 'LIST' }, 'Score'],
    transformResponse: (response: FormTypes['skillsBackendPayload'][]) => {
      if (userLanguage === ValidLanguages.es) {
        successHandler(SuccessMessageEs.SKILLS_SAVE, true);
      } else {
        successHandler(SuccessMessageEn.SKILLS_SAVE, true);
      }
      return response.map((skill: FormTypes['skillsBackendPayload']) => {
        return {
          Id: skill?.Id,
          CertificationId: { val: skill?.CertificationId },
          Skill: { Title: skill?.Skill.Title },
          SkillLevel: { val: skill?.SkillLevel },
          certDate: {
            val: skill?.CertificationDate
              ? `${skill?.CertificationDate.split('-')[0]}-${
                  skill?.CertificationDate.split('-')[1]
                }`
              : '',
          },
          CertificationUrl: { val: skill?.CertificationUrl },
          IsVerified: { val: !!skill.IsVerified },
        };
      });
    },
    transformErrorResponse: (error) => {
      if (error.status === 409) {
        errorHandler(
          '[setSkillsAction]',
          userLanguage === ValidLanguages.es
            ? ErrorMessageEs.SkillExists
            : ErrorMessageEn.SkillExists,
          error,
          true
        );
      } else {
        errorHandler(
          '[setSkillsAction]',
          userLanguage === ValidLanguages.es
            ? ErrorMessageEs.InfoFail
            : ErrorMessageEn.InfoFail,
          error,
          true
        );
      }
    },
  });
